"use client";
import Link from "next/link";
import { useTranslations } from "next-intl";

interface AuthFormFooterProps {
  introText: string;
}

export default function AuthFormFooter({ introText }: AuthFormFooterProps) {
  const t = useTranslations("auth");

  return (
    <div className="mt-5 text-center">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        {introText}{" "}
        <Link
          href="/legal/terms-of-services"
          className="text-brand-teal hover:underline"
        >
          {t("footer.terms_of_service")}
        </Link>
        {" "}{t("footer.and")}{" "}
        <Link
          href="/legal/terms-of-services#politica-de-privacidad"
          className="text-brand-teal hover:underline"
        >
          {t("footer.privacy_policy")}
        </Link>
        .
      </p>
    </div>
  );
}
